function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.054,33.008c0.195,0.195,0.451,0.293,0.708,0.293c0.256,0,0.512-0.098,0.707-0.293l2.525-2.522 c0.188-0.188,0.293-0.441,0.293-0.707s-0.105-0.52-0.293-0.707l-2.525-2.523c-0.391-0.391-1.024-0.391-1.415,0 c-0.39,0.391-0.39,1.024,0,1.414l0.817,0.816h-6.901l-1.877-1.874c-0.392-0.39-1.024-0.391-1.414,0.002 c-0.391,0.391-0.39,1.023,0.001,1.414l2.17,2.166c0.188,0.187,0.441,0.292,0.707,0.292h7.314l-0.816,0.815 C36.664,31.983,36.664,32.617,37.054,33.008z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.287,19.824h8.891l1.919,1.914c0.195,0.194,0.451,0.292,0.706,0.292c0.256,0,0.513-0.098,0.708-0.294 c0.39-0.391,0.389-1.024-0.002-1.414l-2.211-2.206c-0.188-0.187-0.441-0.292-0.706-0.292h-9.304c-0.552,0-1,0.447-1,1 S9.735,19.824,10.287,19.824z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.287,30.778h9.404c0.265,0,0.519-0.105,0.707-0.293l10.673-10.661h6.799l-0.816,0.814 c-0.391,0.391-0.391,1.024-0.001,1.415c0.195,0.195,0.451,0.293,0.708,0.293c0.256,0,0.512-0.098,0.707-0.293l2.525-2.521 c0.188-0.188,0.293-0.442,0.293-0.708s-0.105-0.52-0.293-0.707l-2.525-2.523c-0.391-0.391-1.024-0.391-1.415,0 c-0.39,0.391-0.39,1.024,0,1.414l0.817,0.816h-7.214c-0.265,0-0.519,0.105-0.707,0.293L19.277,28.778h-8.99c-0.552,0-1,0.447-1,1 S9.735,30.778,10.287,30.778z"
});

function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.b510e18c.svg";
export { ForwardRef as ReactComponent };